module.exports = __webpack_public_path__ + "img/JAOC_POP_Mozzarella_Icon.d37ec22f.png";